/* FAQ chat: question list -> chat replies, "Ask next" chips and keyword search over the written answers. */
(function () {
  'use strict';
  var STOP = /^(the|a|an|is|are|do|does|did|i|my|me|can|how|what|to|of|and|or|for|in|it|on|with|this|that|should|will|be|you|your)$/;

  function init(root) {
    var qBtns = [].slice.call(root.querySelectorAll('[data-faq-q]'));
    var log = root.querySelector('[data-faq-log]');
    var chips = root.querySelector('[data-faq-chips]');
    var form = root.querySelector('[data-faq-form]');
    var input = root.querySelector('[data-faq-input]');
    var count = root.querySelector('[data-faq-count]');
    var bar = root.querySelector('[data-faq-bar]');
    var cta = root.querySelector('[data-faq-cta]');
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    var items = qBtns.map(function (b, i) {
      var a = root.querySelector('[data-faq-a="' + i + '"] [data-faq-body]');
      var q = b.querySelector('.sk-fchat__q-text').textContent.trim();
      return { i: i, btn: b, q: q, html: a ? a.innerHTML : '', text: (q + ' ' + (a ? a.textContent : '')).toLowerCase() };
    });
    var done = {}, busy = false, timer = null;

    function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
    function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }
    function toBottom() { log.scrollTo({ top: log.scrollHeight, behavior: reduce ? 'auto' : 'smooth' }); }
    function userRow(text) { var r = el('div', 'sk-fchat__row sk-fchat__row--user'); r.appendChild(el('div', 'sk-fchat__bubble', esc(text))); return r; }
    function botRow(html) { var r = el('div', 'sk-fchat__row sk-fchat__row--bot'); r.appendChild(el('span', 'sk-fchat__mini', 'SK')); r.appendChild(el('div', 'sk-fchat__bubble', html)); return r; }

    function progress() {
      var n = Object.keys(done).length;
      count.textContent = n + ' of ' + items.length + ' answered';
      bar.style.width = (items.length ? n / items.length * 100 : 0) + '%';
    }

    function renderChips(exceptIdx) {
      chips.innerHTML = '';
      var pool = items.filter(function (it) { return !done[it.i] && it.i !== exceptIdx; });
      if (!pool.length) pool = items.filter(function (it) { return it.i !== exceptIdx; }).slice(0, 4);
      pool.slice(0, 8).forEach(function (it) {
        var c = el('button', 'sk-fchat__chip'); c.type = 'button'; c.textContent = it.q;
        c.addEventListener('click', function () { ask(it.i); });
        chips.appendChild(c);
      });
      chips.scrollLeft = 0;
    }

    function clearEmpty() { var e = log.querySelector('.sk-fchat__empty'); if (e) e.remove(); }

    function reply(build, after) {
      busy = true;
      var typing = botRow('<span class="sk-fchat__dots"><i></i><i></i><i></i></span>');
      log.appendChild(typing); toBottom();
      timer = setTimeout(function () {
        typing.remove(); log.appendChild(build()); toBottom(); busy = false; if (after) after();
      }, reduce ? 0 : 650);
    }

    function ask(i, silent) {
      if (busy) return;
      var it = items[i]; if (!it) return;
      clearEmpty();
      log.appendChild(userRow(it.q));
      qBtns.forEach(function (b) { b.classList.toggle('is-active', b === it.btn); });
      reply(function () { return botRow(it.html); }, function () { done[i] = true; it.btn.classList.add('is-done'); progress(); renderChips(i); });
      toBottom();
    }

    function search(text) {
      var words = text.toLowerCase().split(/[^a-z0-9]+/).filter(function (w) { return w.length > 2 && !STOP.test(w); });
      var best = null, bestScore = 0;
      items.forEach(function (it) {
        var s = 0;
        words.forEach(function (w) {
          if (it.q.toLowerCase().indexOf(w) > -1) s += 3;
          else if (it.text.indexOf(w) > -1) s += 1;
        });
        if (s > bestScore) { bestScore = s; best = it; }
      });
      return bestScore > 0 ? best : null;
    }

    function freeText(text) {
      if (busy) return;
      clearEmpty();
      log.appendChild(userRow(text));
      var hit = search(text);
      if (hit) {
        qBtns.forEach(function (b) { b.classList.toggle('is-active', b === hit.btn); });
        reply(function () { return botRow(hit.html); }, function () { done[hit.i] = true; hit.btn.classList.add('is-done'); progress(); renderChips(hit.i); });
      } else {
        var msg = root.getAttribute('data-empty-reply') || 'We have not written an answer to that yet.';
        var wa = cta && cta.querySelector('.sk-faq-cta__btn--whatsapp');
        var extra = wa ? '<p><a href="' + esc(wa.getAttribute('href')) + '" target="_blank" rel="noopener">Message us on WhatsApp</a></p>' : '';
        reply(function () { return botRow('<p>' + esc(msg) + '</p>' + extra); }, function () { renderChips(-1); });
      }
      toBottom();
    }

    function reset() {
      clearTimeout(timer); busy = false; done = {};
      log.innerHTML = '<p class="sk-fchat__empty">Pick a question, or type your own below.</p>';
      qBtns.forEach(function (b) { b.classList.remove('is-done', 'is-active'); });
      progress(); renderChips(-1);
    }

    qBtns.forEach(function (b, i) { b.addEventListener('click', function () { ask(i); }); });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = input.value.trim(); if (!v) return;
      input.value = ''; freeText(v);
    });
    root.querySelector('[data-faq-clear]').addEventListener('click', reset);

    reset();
    if (items.length) ask(0);
  }

  function boot() { [].forEach.call(document.querySelectorAll('[data-faq-chat]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
